/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LifePaymentInfoGroup } from './LifePaymentInfoGroup';
import {
    LifePaymentInfoGroupFromJSON,
    LifePaymentInfoGroupFromJSONTyped,
    LifePaymentInfoGroupToJSON,
    LifePaymentInfoGroupToJSONTyped,
} from './LifePaymentInfoGroup';

/**
 * 
 * @export
 * @interface ContractPaymentInfo
 */
export interface ContractPaymentInfo {
    /**
     * 
     * @type {Array<LifePaymentInfoGroup>}
     * @memberof ContractPaymentInfo
     */
    list: Array<LifePaymentInfoGroup>;
    /**
     * 
     * @type {number}
     * @memberof ContractPaymentInfo
     */
    clientCredit: number;
    /**
     * 
     * @type {number}
     * @memberof ContractPaymentInfo
     */
    employerCredit: number;
    /**
     * 
     * @type {string}
     * @memberof ContractPaymentInfo
     */
    paymentMethod: string;
}

/**
 * Check if a given object implements the ContractPaymentInfo interface.
 */
export function instanceOfContractPaymentInfo(value: object): value is ContractPaymentInfo {
    if (!('list' in value) || value['list'] === undefined) return false;
    if (!('clientCredit' in value) || value['clientCredit'] === undefined) return false;
    if (!('employerCredit' in value) || value['employerCredit'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    return true;
}

export function ContractPaymentInfoFromJSON(json: any): ContractPaymentInfo {
    return ContractPaymentInfoFromJSONTyped(json, false);
}

export function ContractPaymentInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractPaymentInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(LifePaymentInfoGroupFromJSON)),
        'clientCredit': json['clientCredit'],
        'employerCredit': json['employerCredit'],
        'paymentMethod': json['paymentMethod'],
    };
}

export function ContractPaymentInfoToJSON(json: any): ContractPaymentInfo {
    return ContractPaymentInfoToJSONTyped(json, false);
}

export function ContractPaymentInfoToJSONTyped(value?: ContractPaymentInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'list': ((value['list'] as Array<any>).map(LifePaymentInfoGroupToJSON)),
        'clientCredit': value['clientCredit'],
        'employerCredit': value['employerCredit'],
        'paymentMethod': value['paymentMethod'],
    };
}

